<template>
<span @click="goToDashboard()" style="margin-right: 25px;    align-self: center; cursor: pointer" title="Dashboard">
          <img
            :src="'/static/icons/dashboard.svg'"
            height="25"
          />
      </span>
</template>

<script>

export default {
  name: "TemplateDashboardSelector",

  methods: {
    goToDashboard: async function () {
      await this.$router.push("/dashboard");
    },
  },
};
</script>
<style lang="scss" scoped>
@import '../../assets/css/variables.scss';

.label{
  text-transform: uppercase;
  font-size: 1.1em;
  color: $primary-color;
  font-family: $font-subtitle-light;
  margin: 5px;
}

.lang-image {
  position: relative;
  top: -3px;
}
.selected {
  font-weight: bold;
}
i.icon.icon-language {
  height: 1.2em;
  width: 1.2em;
}

</style>
